import * as z from 'zod';
import { type AuthProviderProps } from 'react-oidc-context';

import { deepFreeze } from '#packages/data-collection/utils/object';
import { OAuth2Scopes } from '#packages/api/services/scope-authorization';

export const LOGOUT_REDIRECT_URI = new URL(
  '',
  window.location.origin,
).toString();
export const REDIRECT_URI = new URL('', window.location.origin).toString();

export const CLIENT_ID = z
  .string()
  .nonempty()
  .parse(import.meta.env.APP_CLIENT_WEB_OIDC_CLIENT_ID);

export const authProviderConfig: AuthProviderProps = deepFreeze({
  authority: z
    .url()
    .nonempty()
    .parse(import.meta.env.APP_CLIENT_WEB_OIDC_AUTHORITY),

  client_id: CLIENT_ID,

  response_type: 'code',
  redirect_uri: REDIRECT_URI,

  scope: `aws.cognito.signin.user.admin email openid phone profile ${OAuth2Scopes.PublicApi.scope}`,
});
